export default {
  messages: {
    gather:
      'Documents signatures information is being gathered from the Blockchain.',
    processing: 'Proccessing your information',
  },
  tooltip: 'Opens in a new window',
  loader: 'Please wait',
  intercom: {
    start:
      'Hi, are you having trouble finding out how to use the ID documents stored in your wallet?',
    compatible:
      "Hi. It seems you're not on a browser compatible with WalliD TSP validation. Have you tried opening this link on Chrome or Firefox?",
    wallet: 'Hi, are you having trouble creating a wallet?',
    button:
      "Hi, seems like the button you're clicking is not working. Let us see what we can do to help.",
    metamask:
      "Hi, it seems like you don't have a wallet installed yet. Do you need help setting one up?",
    login:
      "Hi, seems like you haven't logged in your wallet yet. Check out your wallet plug-in. I'm here if you still have any doubts.",
    stored:
      'Hi, are you having trouble finding out how to use the ID documents stored in your wallet?',
    noID:
      "Hi, seems like you can't reach any valid ID document in your wallet. have you already stored one?",
    authorize:
      'Hi, you need to authorize the access to your wallet in your wallet plug-in. Let me know if you are having any trouble with that',
    sign:
      'Hi, you need to sign the document on the button at the bottom right in order to complete the signature proccess. Do you need any help?',
    invalid:
      'Hi, it seems like there was a problem validating your ID document. Are you sure you have a valid one stored in your wallet?',
    failSign:
      'Hi, seems like there was a problem with your document signature. Let me see what I can do to help.',
  },
  errors: {
    revoked: 'Identity document certificate revoked.',
    invalid: 'TSP failed to validate identity.',
    identity: 'TSP failed to get your identity',
    expired: 'TSP failed to validate identity due to session expiration.',
    decrypt: 'Failed to decrypt your identity! Try Again!',
    token: 'TSP failed to sign document due to an unauthorized token.',
    noMetamask: ['No wallet detected. To continue please connect with '],
    loggedOut:
      'You’re not connected to your wallet. Please sign in to your wallet in the pop-up presented by your digital wallet.',
    noWallet: "It seems like you don't have a digital wallet yet.",
    noIdentities:
      'It seems like you haven’t stored an ID document in your digital wallet yet.',
    noComp:
      'It seems like this browser you\'re using is not compatible with WalliD signature. To continue, please download Google Chrome and once there, open again your email and click the "Review document" button.',
  },
  welcome: {
    title: 'Welcome to WalliD’s TSP for Docusign',
    text1: 'You’ve been requested to sign a document in a legally binding way.',

    text2:
      "You’ll need to download <span style='font-weight:700'> MyWalliD wallet </span> plug-in and <span style='font-weight:700'> a valid ID document stored in it </span> to complete the signature process and you can do it in a few instants with WalliD.",
    textNoWallet:
      "After installing MyWalliD wallet in your browser <span style='font-weight:700'> you will need to setup it </span> and store <span style='font-weight:700'> a valid ID document in it </span> to complete the signature process.",

    text3: [
      "If you haven't stored your ID document in your wallet yet, please do it on",
      " WalliD's website",
      'and come back to this page to resume your signature.',
    ],
    terms: [
      " Please accept WalliD's TSP for DocuSign",
      '  terms and conditions.',
    ],
  },

  step: {
    1: 'Provide your Identity',
    2: 'Decrypt your data locally',
    3: 'Verify your data',
  },
  decrypt: {
    title: 'Step 2 - Decrypt your data locally',
    data: 'Your Encrypted data:',
    text: [
      'This is your ID document encrypted with the password you defined on',
      'WalliD.io website',
      'when storing it on the blockchain. Please decrypt it with that password below:',
    ],
    password: ['Password', 'Your password must have at least 6 characters'],
    disclaimer: [
      'Disclaimer',
      'Current Metamask build doesn’t support the features do encrypt data with users’private keys. It will be available as soon. You can encrypt your ID data with a passwrod of your choice',
      'Recommended action',
      'Otherwise you can choose to allow WalliD to encrypt your ID data with a default password',
      'We do not recommend this action',
    ],
  },
  verify: {
    title: 'Verify your data and sign the document',
    data: 'Your ID document:',
  },
  sign: {
    title: 'Your ID has been successfully verified',
    text1:
      'Your ID attributes and digital certificate have been successfully verified by your ID document Certificate Authority.',
    text2:
      'WalliD TSP for DocuSign will sign the document with its certificate after you click the "Sign document" button.',
  },
  successfull: {
    title: 'Your document has been successfully signed!',
    text1: [
      ' The envelope ID',
      'with the documents: ',
      "has been successfully signed by WalliD TSP for DocuSign's certificate.",
    ],
    text2: [
      'After all interested parties have signed the document, you can validate the certified document signatures in  ',
      '  WalliD TSP for DocuSign',
    ],
  },

  walletSign: {
    option: 'Sign with Wallet Address',
  },
  button: {
    begin: 'CONTINUE',
    download: 'Download Google Chrome',
    provide: 'PROVIDE',
    decrypt: 'DECRYPT',
    verify: 'VERIFY',
    sign: 'SIGN DOCUMENT',
    back: 'BACK',
    cancel: 'CANCEL',
    store: 'STORE ID IN DIGITAL WALLET',
  },
};
